export enum ENGINES {
  DOVE = 'DOVE', // Amazon Dove Ads
  MSA = 'MSA', // Microsoft Ads
  PIQ = 'PIQ' // Promote IQ Ads
}

export const engineAdsPriorityOrder = [ENGINES.DOVE, ENGINES.PIQ, ENGINES.MSA];
export const FEATURE_DOVE_ADS = 'marty.ads.dove';
export const FEATURE_PIQ_ADS = 'marty.ads.piq';
export const FEATURE_MSA_ADS = 'marty.ads.msa';

export const AD_PLACEMENT_COUNTS = {
  top: {
    min: 4,
    max: 4
  },
  bottom: {
    min: 4,
    max: 40
  }
};

export const TOP_ROW_RETURNED_AD_AMOUNT = 4;
export const BOTTOM_ROW_RETURNED_AD_AMOUNT = 40;

export const TOP_PLACEMENT = 'sponsoredAds.results.top';
export const BOTTOM_PLACEMENT = 'sponsoredAds.results.bottom';
